/*
 * Switch between aws and electron filesystem
 * based on mode
 * */

import { getUrl as awsGetUrl, GetUrlWithPathOutput } from "aws-amplify/storage";
import { GetUrlInput } from "@aws-amplify/storage/src/internals/types/inputs";
import { GetUrlWithPathInput } from "@aws-amplify/storage/src/providers/s3/types";

async function getElectronMediaUrl(key) {
  // Im Electron-Mode immer media:// protocol mit relativem Pfad verwenden
  if (window.updater) {
    // S3 speichert mit "public/" prefix, also ergänzen
    return `media://public/${key}`;
  }
  // Fallback to /public/media if not in electron context
  return `/media/${key}`;
}

export const getUrl = async (config: GetUrlWithPathInput): Promise<GetUrlWithPathOutput | { url: string } | Error> => {
  if (import.meta.env.MODE === "electron") {
    try {
      const f = await getElectronMediaUrl(config.path || config.key);
      return { url: f };
    } catch (e) {
      return new Error("Keine Datei gefunden");
    }
  } else {
    return awsGetUrl(config);
  }
};
